import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import UserAvatar from 'components/ui/user-avatar/UserAvatar'
import { IMainState } from 'store/states'
import SupervisorAvatar from 'components/ui/user-avatar/SupervisorAvatar'
import { usePermissionsList } from 'hooks/usePermissionsList'
import styles from './styles.module.scss'

const prefixUserList = 'configuration.users.list'
const translateHeaderPrefix = `${prefixUserList}.headers`

export const useColumns = () => {
  const { t } = useTranslation()

  const lmsProfileList = useSelector(
    ({ lmsProfiles }: IMainState) => lmsProfiles.allProfilesList
  )

  const permissionsList = usePermissionsList()

  const columns = useMemo(
    () => [
      {
        title: t(`${translateHeaderPrefix}.name`),
        key: 'full_name',
        render: ({ fullName, position, avatar, id, roleId }: any) => (
          <a
            href={`/configuration/user/${id}`}
            target="_blank"
            className={styles.profileLink}
          >
            <UserAvatar
              user={{
                fullName: fullName || '',
                position: position || '',
                avatar: avatar || '',
                roleId,
              }}
              className={styles.userData}
              showAdmin={true}
            />
          </a>
        ),
        sorteable: true,
      },
      {
        title: t(`${translateHeaderPrefix}.position`),
        key: 'position',
        visible: false,
      },
      {
        title: t(`${translateHeaderPrefix}.identifier`),
        key: 'identifier',
        sorteable: true,
      },
      { title: t(`${translateHeaderPrefix}.area`), key: 'area_name' },
      {
        title: t(`${translateHeaderPrefix}.lmsProfile`),
        key: 'lms_profiles_id',
        variant: 'tag',
        type: 'tagsList',
        list: lmsProfileList
          .map(({ id, name, color }) => ({ value: id, label: name, color }))
          .sort((A, B) => A.label.localeCompare(B.label)),
      },
      {
        title: t(`${translateHeaderPrefix}.role.title`),
        key: 'role_id',
        visible: false,
        type: 'list',
        list: permissionsList,
      },
      {
        title: t(`${translateHeaderPrefix}.role.supervisor`),
        key: 'supervisor_name',
        filterable: false,

        render: (supervisors: any) => (
          <>
            {supervisors.map((supervisor, index) => (
              <SupervisorAvatar
                key={index}
                user={{
                  fullName:
                    supervisor?.name + ' ' + supervisor?.lastname ||
                    supervisor?.fullName ||
                    '',
                  position: supervisor?.position || '',
                  avatar: supervisor?.avatar || '',
                  roleId: supervisor?.roleId || '',
                }}
                className={styles.userData}
                showSupervisor={true}
              />
            ))}
          </>
        ),
        sorteable: true,
      },
    ],
    [lmsProfileList, permissionsList, t]
  )

  return columns
}
